// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DbXEF","colBig":"styles_colBig__1PlIu","colSmall":"styles_colSmall__3I1LW"};